import { getGlobalVariable } from '@/app/editor/config/globalVariable';
import { app } from '@/store';
import HELPER from '@/app/utils/HELPER';
import { GET } from '@/app/api';
import api from '@/app/endpoints';

export function reloadAllPreview(pPreviewId: any) {
  setTimeout(function () {
    changeButtonAssignText();

    refreshAllProductAndRelatedProduct(pPreviewId);

    refreshSideBarByEditingCurrent(pPreviewId);
  });
}

function refreshVariantProduct() {
  const $productSelectorInstance = getProductSelectorInstance();
  $productSelectorInstance.refreshVariantSelector();
}

function refreshSideBarByEditingCurrent(pPreviewId: string) {
  const assignedProduct = $('#assign-product-data').val();
  if (assignedProduct === 'assigned-products') {
    // productId = auto là trường hợp chưa chọn product preview nào
    if (pPreviewId === 'auto') {
      // Function assignPreviewUpdate chỉ đang được gọi trong 2 trường hợp
      // 1: open settings
      // 2: save settings
      // Nên hàm xử lý ở trên chỉ updatePId và refresh không chạy vào function assignPreviewUpdate bên trong nên cần update riêng
      sideBarPreviewReloadForCurrentEditing();
    } else {
      // Refresh lại sidebar với product được chọn
      const $gfProductInstance = getProductSelectorInstance();
      $gfProductInstance.refreshPreviewSideBar(pPreviewId);
    }

    refreshVariantProduct();
  }
}

export function getLatestProduct(callback: any, shop: any) {
  const latestProduct = getProductLatest();
  if (Object.keys(latestProduct || {}).length !== 0) {
    callback(latestProduct);
    return;
  }
  const data = {
    productId: 'auto',
  };

  GET(api.getProduct().url, data)
    .then((res) => {
      let product: any = {};
      if (res && res.data) {
        product = res.data.product;
      }

      const jsonData = product;
      app.$store.commit(`app/UPDATE_LATEST_PRODUCT_IN_SHOPIFY`, jsonData);
      setProductLatest(jsonData);
      callback(jsonData);
      product.latest_product = true;
      HELPER.updateProductInList(jsonData);
    })
    .catch((err) => {
      console.log(err);
    });
}

function refreshAllProductAndRelatedProduct(pPreviewId: string) {
  const $gryffBody = getGlobalVariable('gryffBody');
  const query =
    ".module-wrap[data-label='Product'][data-status='dynamic'], .module-wrap[data-label='Related Products'][data-status='dynamic']";
  $gryffBody.find(query).each((i: any, ele: any) => {
    const $target = jQuery(ele);

    // Không lấy product có data-index vì là product nằm trong related
    if (!$target.attr('data-index')) {
      const $productModule = $target.data('gfmodule');
      // Update pId preview cho cả product và related
      if ($productModule) {
        $productModule.updatePIdByAssignedProduct(pPreviewId);
        // Chỉ refresh preview với trường hợp module là product
        if ($target.attr('data-label') === 'Product') {
          $productModule.refresh();
        }
      }
    }
  });
}

/**
 * Change all value of product & related type from auto to latestId
 */
export function changeAllAutoValueToLatestId() {
  const $gryffBody = getGlobalVariable('gryffBody');
  const query = '.module-wrap[data-label="Product"], .module-wrap[data-label="Related Products"]';
  $gryffBody.find(query).each((i: any, ele: any) => {
    const $target = jQuery(ele);
    if (!$target.attr('data-index')) {
      const $productModule = $target.data('gfmodule');
      $productModule.productChangePidToLatestId();
    }
  });
}

export function getProductSelectorInstance() {
  const $gfLeftSideBar = getGlobalVariable('gfLeftSideBar');
  const $mdSettings = $gfLeftSideBar.find('#md-settings');
  const $pSelector = $mdSettings.find('#assigned-product');
  return $pSelector.data('gfproductselector');
}

export function getProductSelectorInstanceCallback(callback: any) {
  const $pSelectorData = getProductSelectorInstance();
  if ($pSelectorData) {
    callback($pSelectorData);
  } else {
    let $pSelectorData: any = null;
    let intervalId: any = null;
    let varCounter = 0;
    const varName = function () {
      // Chạy lại nhỏ hơn 5 lần và $pSelectorData vẫn đang chưa có giá trị
      if (varCounter <= 5 && !$pSelectorData) {
        varCounter++;
        $pSelectorData = getProductSelectorInstance();
        if ($pSelectorData) {
          callback($pSelectorData);
        }
      } else {
        clearInterval(intervalId);
      }
    };
    intervalId = setInterval(varName, 100);
  }
}

export function sideBarPreviewReloadForCurrentEditing() {
  const $target = getCurrentEditing();
  const moduleName = $target.attr('data-label');
  // Cần kiểm tra kiểu product hoặc related product
  if ($target.hasClass('module-wrap') && (moduleName === 'Product' || moduleName === 'Related Products')) {
    $target.data('gfmodule').assignPreviewUpdate(moduleName, 'assigned-products');
  }
}

function getCurrentEditing() {
  const $gfLeftSideBar = getGlobalVariable('gfLeftSideBar');
  const $gryffBody = getGlobalVariable('gryffBody');
  const $mdSettings = $gfLeftSideBar.find('#md-settings');
  const $mdTitle = $mdSettings.find('.md-title .mer-title');
  const merId = $mdTitle.attr('data-id');
  return $gryffBody.find(`#${merId}`);
}
function setProductLatest(jsonData: any) {
  window._productLatest = jsonData;
}

export function getProductLatest() {
  return window._productLatest;
}

export function changeButtonAssignText() {
  const productPicked = getProductPreview();
  const $btnChangePreview = $('#gf-change-preview');
  if (productPicked === 'auto') {
    $btnChangePreview.attr('data-text', 'assign-product');
    $btnChangePreview.html('Assign product');
  } else {
    $btnChangePreview.attr('data-text', 'change-preview');
    $btnChangePreview.html('Change preview');
  }
}

export function getProductPreview() {
  return app.$store.getters['page/GET_ID_PRODUCT_DYNAMIC'];
}

export function trimProductTitlePreview(str: string) {
  const max = 37;
  if (str && str.length > max) {
    return str.substring(0, max) + '...';
  }
  return str;
}

export function changeProductTitlePreview($inputProductTitle: any, productTitle: string) {
  $inputProductTitle.attr('value', productTitle).val(productTitle).trigger('value-change');
  const $gfProductTitle = $inputProductTitle.next('.gfInputField').find('.gfProductTitle');
  $gfProductTitle.html(productTitle);
}

export function getDefaultImage() {
  return HELPER.getDefaultNoImage();
}
